// ─────────────────────────────────────────────────────────────────
// Glass-i — Proforma Settings API client (Stage 6Q.3).
//
// Tenant-wide Proforma calculation defaults (singleton). Thin axios
// wrappers around /api/erp/masters/proforma-settings.
// ─────────────────────────────────────────────────────────────────

import client from '../../../../api/client';

const BASE = '/api/erp/masters/proforma-settings';

function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined
    ? resp.data.data
    : (resp ? resp.data : null);
}

export const proformaSettingsApi = {
  get:    ()        => client.get(BASE).then(unwrap),
  update: (payload) => client.put(BASE, payload).then(unwrap)
};

// Soft-fail loader for surfaces (e.g. the Proforma editor) that only
// want to seed defaults — never block the page on a settings error.
export async function loadProformaSettingsSafe() {
  try { return await proformaSettingsApi.get(); }
  catch (_e) { return null; }
}

export default proformaSettingsApi;
